export default __webpack_public_path__ + "static/media/EMPLOYEES.35d74753.png";